export default (pointTime, frame, searchValue, entityFields) => {
  return {
    namespace: "/bq_summary",
    stale: 1,
    expire: 1,
    queryParams: [
      {
        refName: "endTime",
        field: "created",
        operator: "lt",
        value: pointTime.utc().format("YYYY-MM-DDTHH:mm:ss.SSS999"),
      },
      {
        refName: "startTime",
        field: "created",
        operator: "gt",
        value: pointTime
          .utc()
          .subtract(1, `${frame}s`)
          .format("YYYY-MM-DDTHH:mm"),
      },
      {
        field: "associationType",
        operator: "eq",
        negate: true,
        value: "",
      },
      [
        ...Object.keys(entityFields)
          .filter((field) => !!entityFields[field].validate(searchValue))
          .map((field) => {
            return {
              field,
              operator: entityFields[field].op,
              value: searchValue,
            };
          }),
      ],
    ],
    resultParams: {
      //windows_log_source.count_if.!eq.nxlog-ce=count_non_nxlog_ce
      transform: [
        ...Object.keys(entityFields)
          .filter((field) => !!entityFields[field].validate(searchValue))
          .map((field) => {
            return {
              field: "total",
              negate: false,
              operator: `sum_if.${field}.${entityFields[field].op}.${searchValue}`,
              value: `sum_${field}`,
            };
          }),
        ...Object.keys(entityFields)
          .filter((field) => !!entityFields[field].validate(searchValue))
          .map((field) => {
            return {
              field: field,
              negate: false,
              operator: `count_if.${entityFields[field].op}.${searchValue}`,
              value: `count_${field}`,
            };
          }),
        {
          negate: false,
          operator: "count",
          value: "grouped_count",
        },
        {
          field: "max_timestamp",
          negate: false,
          operator: "extract.YEAR",
          value: "year",
        },
        {
          field: "max_timestamp",
          negate: false,
          operator: "extract.MONTH",
          value: "month",
        },
        {
          field: "max_timestamp",
          negate: false,
          operator: "extract.DAY",
          value: "day",
        },
      ],
      outputFields: [],
    },
  };
};
